import { InteractionEvent } from '@tencent/alloy-renderer';

// 点击或触摸过程中手指移动的容错值
const TOUCH_OFFSET_LIMIT = 10;

/**
 * 判断 react 元素 move 事件是否超出容错值
 */
export class ReactTouchMoveLimitValidator {
    private touchStartTouchList: React.TouchList;

    public touchStart = (event: React.TouchEvent) => {
        this.touchStartTouchList = event.touches;
    };

    public isMoveValid = (event: React.TouchEvent) => {
        if (!this.touchStartTouchList || !event.touches) {
            return true;
        }
        if (this.touchStartTouchList.length !== event.touches.length) {
            return true;
        }
        if (this.touchStartTouchList.length !== 1) {
            return true;
        }
        const [{ clientX: startX, clientY: startY }] = Array.from(this.touchStartTouchList);
        const [{ clientX: moveX, clientY: moveY }] = Array.from(event.touches);
        return Math.abs(moveX - startX) > TOUCH_OFFSET_LIMIT
        || Math.abs(moveY - startY) > TOUCH_OFFSET_LIMIT;
    };
}

/**
 * 判断 alloy-renderer 元素 move 事件是否超出容错值
 */
export class CanvasTouchMoveLimitValidator {
    private touchstartX: number;
    private touchstartY: number;

    public touchStart = (event: InteractionEvent) => {
        this.touchstartX = event.worldX;
        this.touchstartY = event.worldY;
    };

    public isMoveValid = (event: InteractionEvent) => {
        // 兼容 move 前没触发 touchstart 的情况
        // 因为拖拽的元素会被提高层级单独绘制，所以拖拽过程中 move 触发的元素并不是拖拽元素，而是底部其他元素，所以就有可能出现 move 之前没触发 touchstart 的情况
        if (!this.touchstartX) {
            this.touchstartX = event.worldX;
        }
        if (!this.touchstartY) {
            this.touchstartY = event.worldY;
        }
        return (
            Math.abs(event.worldX - this.touchstartX) > TOUCH_OFFSET_LIMIT
            || Math.abs(event.worldY - this.touchstartY) > TOUCH_OFFSET_LIMIT
        );
    };
}
